import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class PdfValidationService {
  private readonly MAX_BASE64_SIZE_BYTES = 25 * 1024 * 1024; // 25MB — eMudhra's gateway payload ceiling

  constructor(private messageService: MessageService) {}

  /**
   * Validates that a Base64-encoded payload stays within eMudhra's 25MB
   * gateway limit. Acts as a final safety net for the multi-file merge path,
   * where several individually-valid files can still combine into an
   * oversized payload even though each is under the per-file cap.
   * @param base64String - The base64 string to validate (with or without data URL prefix)
   * @param fileName - Optional file name for error message
   * @returns boolean - true if valid, false if exceeds limit
   */
  validateBase64String(base64String: string, fileName?: string): boolean {
    try {
      // Remove data URL prefix if present
      const base64Content = base64String.includes(',')
        ? base64String.split(',')[1]
        : base64String;

      // Calculate actual size in bytes
      const base64SizeInBytes = (base64Content.length * 3) / 4;
      console.log("base64SizeInBytes==>", base64SizeInBytes)

      if (base64SizeInBytes > this.MAX_BASE64_SIZE_BYTES) {
        const fileNamePrefix = fileName ? `${fileName} ` : '';
        this.messageService.add({
          severity: 'error',
          summary: 'File Too Large',
          detail: `${fileNamePrefix}contains too many images/tables. Base64 size exceeds the 25MB e-sign gateway limit. Please use a different PDF or upload fewer files at once.`,
          life: 5000,
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error('Base64 validation error:', error);
      return false;
    }
  }
}
